// extracted by mini-css-extract-plugin
module.exports = {"fieldLinkColor":"FieldLinkComponent_fieldLinkColor__1Uyu7"};